import { GatsbyImage } from 'gatsby-plugin-image'
import React, { useRef, useState } from 'react'
import { Autoplay, EffectFade } from 'swiper'
import 'swiper/css'
import 'swiper/css/effect-fade'
import 'swiper/css/navigation'
import { Swiper, SwiperSlide } from 'swiper/react'
import Spacer from './spacer'

const Testimonials = ({ testimonials }) => {
	const [activeIndex, setActiveIndex] = useState(0)
	const swiperRef = useRef(null)

	const handleSlideClick = index => {
		if (swiperRef.current && swiperRef.current.swiper) {
			swiperRef.current.swiper.slideTo(index)
		}
	}

	return (
		<div>
			<div className="pl40 pr40 pb40">
			<p className="h1  max-1400 ma">Testimonials</p>
			</div>
			<Swiper ref={swiperRef} slidesPerView={'1'} modules={[EffectFade, Autoplay]} effect='fade' speed={850} fadeEffect={{ crossFade: true }} autoplay={{ delay: 8000, disableOnInteraction: false }} onSlideChange={swiper => setActiveIndex(swiper.activeIndex)}>
				{testimonials.map(({ title, image, paragraph, id }) => (
					<SwiperSlide key={id}>
						<div className={'testimonals bg-white flex pl40 pr40 h-80vh m-h100  '}>
							<div className='max-1400 mla mra w-100 flex '>
								<div className=' m-100 m-p0 flex flex-wrap  align-bottom mr20  m-m0'>
									<div className='w-100 flex-grow flex-grow-unset align-self--top'>
										<div className={'m0  banner--title align-self--top  w-100 '}>
											<div className='m0 pt20  m-flex'>
												<div className=' p mr20 m-max-100'>{title} </div>
												<div className='max-100 w-100 mla m-show  '>
													<div className='ratio-2-1 bg-grey banner--image mb40  '>
														<GatsbyImage className='bg-image' image={image?.gatsbyImageData} alt={image?.alt || title} />
													</div>
												</div>
											</div>
										</div>
									</div>
									<div className='text-bottom max-700 align-self--bottom m-align-self--unset '>
										<Spacer className='m-hide ' />
										<h3 className='h3 m0'> {paragraph}</h3>
									</div>
								</div>
								<div className='max-180 w-100 mla m-hide mla    '>
									<div className='ratio-2-1 bg-grey sticky--top mb40 banner--image m-t70      '>
										<GatsbyImage className='bg-image' image={image?.gatsbyImageData} alt={image?.alt || title} />
									</div>
								</div>
							</div>
						</div>
					</SwiperSlide>
				))}
			</Swiper>
			<div className='p40 mt40'>
				<menu className='flex p0 align-center max-1400 ma gap-10'>
					{testimonials.map(({ image, id }, index) => (
						<button key={id} onClick={() => handleSlideClick(index)} className={`ratio-2-3 max-100 pos-rel bg-grey overflow swiper-thumbnail ${index === activeIndex ? 'active' : ''}`}>
							<GatsbyImage image={image?.gatsbyImageData} alt={image?.alt || ''} className='bg-image' />
						</button>
					))}
				</menu>
			</div>
		</div>
	)
}

export default Testimonials
